import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Regenerate Thumbnail Image
  thumbnailRegenerateRequest: ['thumbnailId', 'prompt', 'callback'],
  thumbnailRegenerateSuccess: ['data'],
  thumbnailRegenerateFailure: ['error'],

  // Get Thumbnail Status
  thumbnailStatusRequest: ['thumbnailId', 'callback'],
  thumbnailStatusSuccess: ['status'],
  thumbnailStatusFailure: ['error'],

  // Poll Thumbnail Until Complete
  thumbnailPollRequest: ['thumbnailId', 'interval', 'callback'],
  thumbnailPollSuccess: ['data'],
  thumbnailPollFailure: ['error'],

  // Get Thumbnail History
  thumbnailHistoryRequest: ['thumbnailId', 'callback'],
  thumbnailHistorySuccess: ['history'],
  thumbnailHistoryFailure: ['error'],

  // Select From History
  thumbnailSelectHistoryRequest: ['thumbnailId', 'historyIndex', 'callback'],
  thumbnailSelectHistorySuccess: ['data'],
  thumbnailSelectHistoryFailure: ['error'],

  // ============ Animation ============
  // Generate Animation
  animationGenerateRequest: ['thumbnailId', 'animationPrompt', 'force', 'callback'],
  animationGenerateSuccess: ['data'],
  animationGenerateFailure: ['error'],

  // Get Animation Status
  animationStatusRequest: ['thumbnailId', 'callback'],
  animationStatusSuccess: ['status'],
  animationStatusFailure: ['error'],

  // Poll Animation Until Complete
  animationPollRequest: ['thumbnailId', 'interval', 'callback'],
  animationPollSuccess: ['data'],
  animationPollFailure: ['error'],

  // Regenerate Animation
  animationRegenerateRequest: ['thumbnailId', 'callback'],
  animationRegenerateSuccess: ['data'],
  animationRegenerateFailure: ['error'],

  // Skip Animation
  animationSkipRequest: ['thumbnailId', 'callback'],
  animationSkipSuccess: ['data'],
  animationSkipFailure: ['error'],

  // ============ Batch Animation ============
  // Batch Generate Animations
  animationBatchGenerateRequest: ['scriptId', 'callback'],
  animationBatchGenerateSuccess: ['data'],
  animationBatchGenerateFailure: ['error'],

  // Get Batch Animation Status
  animationBatchStatusRequest: ['scriptId', 'callback'],
  animationBatchStatusSuccess: ['status'],
  animationBatchStatusFailure: ['error'],

  // Poll Batch Animation Until Complete
  animationBatchPollRequest: ['scriptId', 'interval', 'callback'],
  animationBatchPollSuccess: ['data'],
  animationBatchPollFailure: ['error'],

  // Reset
  thumbnailReset: [],
})

export const ThumbnailTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // Regenerate
  regenerateFetching: false,
  regenerateError: null,

  // Status
  status: null,
  statusFetching: false,
  statusError: null,

  // History
  history: [],
  historyFetching: false,
  historyError: null,

  // Animation
  animationFetching: false,
  animationError: null,
  animationStatus: null,

  // Batch Animation
  batchStatus: null,
  batchFetching: false,
  batchError: null,

  // Polling
  polling: false,
  pollError: null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Regenerate
    case Types.THUMBNAIL_REGENERATE_REQUEST:
      return { ...state, regenerateFetching: true, regenerateError: null }
    case Types.THUMBNAIL_REGENERATE_SUCCESS:
      return { ...state, regenerateFetching: false, regenerateError: null }
    case Types.THUMBNAIL_REGENERATE_FAILURE:
      return { ...state, regenerateFetching: false, regenerateError: action.error }

    // Status
    case Types.THUMBNAIL_STATUS_REQUEST:
      return { ...state, statusFetching: true, statusError: null }
    case Types.THUMBNAIL_STATUS_SUCCESS:
      return { ...state, status: action.status, statusFetching: false, statusError: null }
    case Types.THUMBNAIL_STATUS_FAILURE:
      return { ...state, statusFetching: false, statusError: action.error }

    // Poll
    case Types.THUMBNAIL_POLL_REQUEST:
      return { ...state, polling: true, pollError: null }
    case Types.THUMBNAIL_POLL_SUCCESS:
      return { ...state, polling: false, pollError: null }
    case Types.THUMBNAIL_POLL_FAILURE:
      return { ...state, polling: false, pollError: action.error }

    // History
    case Types.THUMBNAIL_HISTORY_REQUEST:
      return { ...state, historyFetching: true, historyError: null }
    case Types.THUMBNAIL_HISTORY_SUCCESS:
      return { ...state, history: action.history, historyFetching: false, historyError: null }
    case Types.THUMBNAIL_HISTORY_FAILURE:
      return { ...state, historyFetching: false, historyError: action.error }

    // Select History
    case Types.THUMBNAIL_SELECT_HISTORY_REQUEST:
      return { ...state, regenerateFetching: true, regenerateError: null }
    case Types.THUMBNAIL_SELECT_HISTORY_SUCCESS:
      return { ...state, regenerateFetching: false, regenerateError: null }
    case Types.THUMBNAIL_SELECT_HISTORY_FAILURE:
      return { ...state, regenerateFetching: false, regenerateError: action.error }

    // Animation Generate
    case Types.ANIMATION_GENERATE_REQUEST:
      return { ...state, animationFetching: true, animationError: null }
    case Types.ANIMATION_GENERATE_SUCCESS:
      return { ...state, animationFetching: false, animationError: null }
    case Types.ANIMATION_GENERATE_FAILURE:
      return { ...state, animationFetching: false, animationError: action.error }

    // Animation Status
    case Types.ANIMATION_STATUS_REQUEST:
      return { ...state, statusFetching: true, statusError: null }
    case Types.ANIMATION_STATUS_SUCCESS:
      return { ...state, animationStatus: action.status, statusFetching: false, statusError: null }
    case Types.ANIMATION_STATUS_FAILURE:
      return { ...state, statusFetching: false, statusError: action.error }

    // Animation Poll
    case Types.ANIMATION_POLL_REQUEST:
      return { ...state, polling: true, pollError: null }
    case Types.ANIMATION_POLL_SUCCESS:
      return { ...state, polling: false, pollError: null }
    case Types.ANIMATION_POLL_FAILURE:
      return { ...state, polling: false, pollError: action.error }

    // Animation Regenerate
    case Types.ANIMATION_REGENERATE_REQUEST:
      return { ...state, animationFetching: true, animationError: null }
    case Types.ANIMATION_REGENERATE_SUCCESS:
      return { ...state, animationFetching: false, animationError: null }
    case Types.ANIMATION_REGENERATE_FAILURE:
      return { ...state, animationFetching: false, animationError: action.error }

    // Animation Skip
    case Types.ANIMATION_SKIP_REQUEST:
      return { ...state, animationFetching: true, animationError: null }
    case Types.ANIMATION_SKIP_SUCCESS:
      return { ...state, animationFetching: false, animationError: null }
    case Types.ANIMATION_SKIP_FAILURE:
      return { ...state, animationFetching: false, animationError: action.error }

    // Batch Animation
    case Types.ANIMATION_BATCH_GENERATE_REQUEST:
      return { ...state, batchFetching: true, batchError: null }
    case Types.ANIMATION_BATCH_GENERATE_SUCCESS:
      return { ...state, batchFetching: false, batchError: null }
    case Types.ANIMATION_BATCH_GENERATE_FAILURE:
      return { ...state, batchFetching: false, batchError: action.error }

    case Types.ANIMATION_BATCH_STATUS_REQUEST:
      return { ...state, batchFetching: true, batchError: null }
    case Types.ANIMATION_BATCH_STATUS_SUCCESS:
      return { ...state, batchStatus: action.status, batchFetching: false, batchError: null }
    case Types.ANIMATION_BATCH_STATUS_FAILURE:
      return { ...state, batchFetching: false, batchError: action.error }

    case Types.ANIMATION_BATCH_POLL_REQUEST:
      return { ...state, polling: true, pollError: null }
    case Types.ANIMATION_BATCH_POLL_SUCCESS:
      return { ...state, polling: false, pollError: null }
    case Types.ANIMATION_BATCH_POLL_FAILURE:
      return { ...state, polling: false, pollError: action.error }

    // Reset
    case Types.THUMBNAIL_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
